import { fork } from 'redux-saga/effects';

// Sagas
import professionSaga from './profession';
import positionSaga from './position';
import countryNationalitySaga from './countryNationality';
import workActivitySaga from './workActivity';
import personalDataSaga from './personalData';
import identitySaga from './identity';
import ufSaga from './uf';
import indicatorsSaga from './indicators';
import participationFeesSaga from './participationFees';
import officesSaga from './offices';
import executiveSaga from './executive';
import banksSaga from './banks';
import accountsTypesSaga from './accountsTypes';
import documentsSaga from './documents';
import signatureSaga from './signature';
import paymentButtonSaga from './paymentButton';
import otpSaga from './otp';
import passwordSaga from './password';
import surveySaga from './survey';

export default function* rootSaga() {
  yield fork(professionSaga);
  yield fork(positionSaga);
  yield fork(countryNationalitySaga);
  yield fork(workActivitySaga);
  yield fork(personalDataSaga);
  yield fork(ufSaga);
  yield fork(indicatorsSaga);
  yield fork(identitySaga);
  yield fork(participationFeesSaga);
  yield fork(officesSaga);
  yield fork(executiveSaga);
  yield fork(banksSaga);
  yield fork(accountsTypesSaga);
  yield fork(documentsSaga);
  yield fork(signatureSaga);
  yield fork(paymentButtonSaga);
  yield fork(otpSaga);
  yield fork(passwordSaga);
  yield fork(surveySaga);
}
